import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/img-no-igredient-candidate.png'
import _imports_1 from '@/assets/images/icon_reload.png'


const _hoisted_1 = { class: "home-page-area" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "home-page-divider" }, null, -1)
const _hoisted_3 = { class: "home-page-recommend-food-title-area" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "commonTextBodyStrong" }, "おすすめ食材", -1)
const _hoisted_5 = {
  key: 1,
  class: "home-page-recommend-food-empty"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "home-page-recommend-food-empty-image",
  src: _imports_0
}, null, -1)
const _hoisted_7 = { class: "home-page-empty-message-1" }
const _hoisted_8 = { class: "home-page-empty-message-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "home-page-divider" }, null, -1)
const _hoisted_10 = { class: "home-page-recommend-food-title-area" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "commonTextBodyStrong" }, "おすすめ献立", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "home-page-recommend-food-menu-title-upload-image",
  src: _imports_1
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "commonButtonText home-page-title-button-name" }, "更新", -1)
const _hoisted_14 = {
  key: 3,
  class: "home-page-recommend-food-empty"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "home-page-recommend-food-empty-image",
  src: _imports_0
}, null, -1)
const _hoisted_16 = { class: "home-page-empty-message-1" }
const _hoisted_17 = { class: "home-page-empty-message-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecommendFoodNoticeToast = _resolveComponent("RecommendFoodNoticeToast")
  const _component_BannerList = _resolveComponent("BannerList")
  const _component_BannerIndicator = _resolveComponent("BannerIndicator")
  const _component_RecommendListTitle = _resolveComponent("RecommendListTitle")
  const _component_ServiceTile = _resolveComponent("ServiceTile")
  const _component_RecommendFoodView = _resolveComponent("RecommendFoodView")
  const _component_RecipeTopList = _resolveComponent("RecipeTopList")
  const _component_CommonRecipeList = _resolveComponent("CommonRecipeList")
  const _component_RecommendFoodMenu = _resolveComponent("RecommendFoodMenu")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_RecommendFoodNoticeToast, {
        class: "home-page-toast",
        isShowToast: _ctx.isShowToast,
        message: _ctx.recommendFoodsUpdateMessage,
        onCloseToast: _ctx.closeToast
      }, null, 8, ["isShowToast", "message", "onCloseToast"]),
      _withDirectives(_createVNode("div", _mergeProps(_ctx.banners, { clsss: "home-page-banner" }), [
        _createVNode(_component_BannerList, _mergeProps(_ctx.banners, {
          class: "home-page-banner-list",
          list: _ctx.bannerList,
          position: _ctx.bannerPosition,
          onOnClick: _ctx.selectBanner,
          onSwipeRight: _ctx.swipeRight,
          onSwipeLeft: _ctx.swipeLeft
        }), null, 16, ["list", "position", "onOnClick", "onSwipeRight", "onSwipeLeft"]),
        _withDirectives(_createVNode(_component_BannerIndicator, _mergeProps(_ctx.banners, {
          class: "home-page-banner-indicator",
          list: _ctx.bannerList,
          position: _ctx.bannerPosition
        }), null, 16, ["list", "position"]), [
          [_vShow, _ctx.isShowBannerIndicator()]
        ])
      ], 16), [
        [_vShow, _ctx.isShowBanner()]
      ]),
      _withDirectives(_createVNode("div", _mergeProps(_ctx.services, { class: "home-page-service" }), [
        _createVNode(_component_RecommendListTitle, {
          class: "home-page-recommend-title",
          title: 'サービス',
          type: _ctx.HOME_RECIPE_TYPE.SERVICE,
          onSelectSeeMore: _ctx.clickSeeMore
        }, null, 8, ["type", "onSelectSeeMore"]),
        _createVNode(_component_ServiceTile, _mergeProps(_ctx.services, {
          class: "home-page-service-tile",
          list: _ctx.serviceList,
          onOnClick: _ctx.selectService
        }), null, 16, ["list", "onOnClick"]),
        _hoisted_2
      ], 16), [
        [_vShow, _ctx.isShowService()]
      ]),
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createVNode("div", {
          class: "commonButtonText",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickStock(...args)))
        }, " 在庫を見る ", 512), [
          [_vShow, _ctx.isShowRecommendFood]
        ])
      ]),
      (_ctx.isShowRecommendFood)
        ? (_openBlock(), _createBlock(_component_RecommendFoodView, {
            key: _ctx.updateFoodKey,
            data: _ctx.foodRecommendationData,
            onSelectFood: _ctx.selectFood
          }, null, 8, ["data", "onSelectFood"]))
        : (_ctx.isShowRecommendFoodEmpty)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.EMPTY_MESSAGE_1), 1),
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.EMPTY_MESSAGE_2), 1)
            ]))
          : _createCommentVNode("", true),
      _hoisted_9,
      _createVNode(_component_RecommendListTitle, {
        class: "home-page-recommend-title",
        title: 'おすすめレシピ',
        type: _ctx.HOME_RECIPE_TYPE.RECOMMEND,
        onSelectSeeMore: _ctx.clickSeeMore
      }, null, 8, ["type", "onSelectSeeMore"]),
      _withDirectives(_createVNode(_component_RecipeTopList, {
        class: "home-page-recipe-top-list",
        recipes: _ctx.topRecommendRecipe,
        onSelectRecipe: _ctx.selectRecipeRecommend
      }, null, 8, ["recipes", "onSelectRecipe"]), [
        [_vShow, _ctx.isShowTopRecommendRecipe()]
      ]),
      _createVNode(_component_CommonRecipeList, {
        recipes: _ctx.recommendRecipes,
        limitCount: 3,
        onSelectRecipe: _ctx.selectRecipeRecommend
      }, null, 8, ["recipes", "onSelectRecipe"]),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createVNode("div", {
          class: "home-page-recommend-food-title-button-area",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickUpdateMenu(...args)))
        }, [
          _hoisted_12,
          _hoisted_13
        ], 512), [
          [_vShow, !_ctx.isShowRecommendFoodMenuEmpty]
        ])
      ]),
      (_ctx.isShowRecommendFoodMenu)
        ? (_openBlock(), _createBlock(_component_RecommendFoodMenu, {
            class: "home-page-recommend-food-menu",
            key: _ctx.updateOneMenuKey,
            data: _ctx.oneMenuRecommendationData,
            onSelectRecipe: _ctx.selectRecipeOneMenu
          }, null, 8, ["data", "onSelectRecipe"]))
        : (_ctx.isShowRecommendFoodMenuEmpty)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.EMPTY_MESSAGE_1), 1),
              _createVNode("div", _hoisted_17, _toDisplayString(_ctx.EMPTY_MESSAGE_2), 1)
            ]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: 9,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      negativeLabel: _ctx.ERROR_BUTTON_LABEL,
      onNegativeClick: _ctx.closeError
    }, null, 8, ["isShowDialog", "title", "message", "negativeLabel", "onNegativeClick"])
  ], 64 /* STABLE_FRAGMENT */))
}